import {IMAGES} from "../../../../image-data";
import React from "react";
import { str } from "../../../Scenarios";

export function EntryImage(props) {
    return(<div className="entry-content content-image">
        <img src={IMAGES.entries[(str.getLanguage() in IMAGES.entries ? str.getLanguage() : 'en')][props.value]} alt={props.title} />
    </div>)
}